import { ContentItem, ContentItemContent, ContentItemTitle } from "./styled";
import { useFetchEntities } from "../../../../reactQueryHooks";
import { useNavigate } from "react-router-dom";

//-------------------------------------------

const SortableTableInfoExternalAssignments = ({ tourGroup }) => {
  const { data: entities } = useFetchEntities();
  const navigate = useNavigate();
  const product = entities?.data?.products?.find(
    (product) => product._id === tourGroup?.product_id
  );

  const option = product?.options.find(
    (option) => option._id === tourGroup?.option_id
  );

  //has at least one external associate role in crewRoles
  const requiresExternalAssignment =
    option?.crewRoles?.some((role) => {
      const roleData = entities?.data?.roles.find((r) => r._id === role);
      return roleData?.isExternalAssociate;
    }) || false;

  //-------------------------------------------

  if (!requiresExternalAssignment) {
    return null;
  }

  return (
    <>
      <ContentItem
        initial={{ opacity: 0, x: -5 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -5 }}
        transition={{ duration: 0.25, delay: 0.4 }}
        onClick={() => {
          navigate(
            `/external_assignments?startDate=${tourGroup?.date}&tourGroupId=${tourGroup?._id}`
          );
        }}
      >
        <ContentItemTitle>External</ContentItemTitle>
        <ContentItemContent>
          {tourGroup?.external_assignments?.length === 0 && (
            <span
              style={{
                color: "indianred",
                fontWeight: "bold",
              }}
            >
              No assignees
            </span>
          )}
          <div className="names">
            {tourGroup?.external_assignments?.map((assignee) => {
              const assigneeData = entities.data.staff.find(
                (user) => user._id === assignee.user_id
              );
              const assigneeRole = entities.data.roles.find(
                (role) => role._id === assignee.role_id
              );
              return (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                  }}
                  key={assignee.user_id}
                >
                  <i
                    style={{
                      fontSize: "8px",
                    }}
                    className="fas fa-user"
                  ></i>
                  <span
                    title={assignee?.projected ? "Projected assignment" : ""}
                    style={{
                      color: assignee?.projected
                        ? "rgb(233 110 110)"
                        : "rgb(41 121 41)",
                    }}
                  >{` ${assigneeData.name} (${assigneeRole.title})`}</span>
                </div>
              );
            })}
          </div>
          {tourGroup?.external_assignments?.length > 0 && (
            <span className="names_hidden">
              <i
                style={{
                  fontSize: "8px",
                }}
                className="fas fa-user"
              ></i>
              <i className="see">see assignees</i>
            </span>
          )}
        </ContentItemContent>
      </ContentItem>
    </>
  );
};

export default SortableTableInfoExternalAssignments;
